import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const options = [{
  title: 'Programul R.I.S.E.',
  subtitle: '12 Workshopuri în 12 Săptămâni',
  description: 'Transformare ghidată, structurată și aplicată.',
  image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=340&fit=crop&crop=center',
  features: ['12 workshopuri online (1 pe săptămână)', 'Acces la înregistrări', 'Materiale practice', 'Exerciții aplicabile', 'Acces GRATUIT la Comunitatea R.I.S.E. (2 sau 3 ani)', 'Suport și claritate în proces'],
  buttonText: 'Înscrie-mă în Program',
  buttonStyle: 'bg-rise-gold text-rise-black hover:bg-rise-gold-light border border-rise-gold',
  href: 'https://comunitatearise.ro/programulrise'
}, {
  title: 'Comunitatea R.I.S.E.',
  subtitle: 'Abonament lunar',
  description: 'Spațiul tău de susținere continuă și creștere pe termen lung. Este pentru tine dacă vrei susținere constantă, fără a intra într-un program intensiv.',
  image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&h=340&fit=crop&crop=faces',
  features: ['Cursuri video', 'Interviuri și podcasturi cu invitați', 'Exerciții video practice', 'Resurse: articole și cărți recomandate', '1 întâlnire online lunară (Q&A + insight-uri)', 'Spațiu de conversații și susținere între membri'],
  buttonText: 'Intră în Comunitate',
  buttonStyle: 'bg-rise-gold text-rise-black hover:bg-rise-gold-light border border-rise-gold',
  href: 'https://comunitatearise.ro/comunitaterise'
}, {
  title: 'Ghidare 1:1 cu Teodora',
  subtitle: 'Premium',
  description: 'Pentru când vrei claritate rapidă și pași personalizați.',
  image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&h=340&fit=crop&crop=center',
  features: ['Blocajul tău principal (emoțional + mental)', 'Decizii asumate, fără frică paralizantă', 'Direcție și plan concret de acțiune', 'Progres măsurabil, nu doar introspecție'],
  buttonText: 'Aplică pentru 1:1',
  buttonStyle: 'bg-rise-gold text-rise-black hover:bg-rise-gold-light border border-rise-gold',
  href: 'https://comunitatearise.ro/coaching1la1'
}];
export function WaysToWork() {
  return <section className="bg-rise-anthracite text-rise-white py-12 md:py-20 px-6" data-id="element-312" data-mp="3na8af0o0b0xp">
      <div className="max-w-rise-content mx-auto" data-id="element-313" data-mp="3jbsf89hrum97">
        <div className="text-center mb-16" data-id="element-314" data-mp="3eauy808hzy9a">
          <h2 className="font-playfair text-[32px] md:text-[38px] mb-4" data-id="element-315" data-mp="3ea31gm35zuhf">
            Modalități de a lucra cu mine
          </h2>
          <p className="font-dm-sans text-rise-white/60 max-w-2xl mx-auto text-[19px]" data-id="element-316" data-mp="34d862c26ua7d">
            Alege formatul care se potrivește cel mai bine nevoilor tale
            actuale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-317" data-mp="12m3grmnq9lq7">
          {options.map((option, index) => <div key={index} className="flex flex-col rounded-xl bg-rise-black text-rise-white shadow-xl relative overflow-hidden border border-rise-gold/40" data-id="element-318" data-mp="1b3dusg6k98jo" data-mpi={index}>
              {/* Card Image */}
              <div className="relative w-full h-[200px] overflow-hidden" data-id="element-319" data-mp="1jvpjnxm10nxj">
                <img src={option.image} alt={option.title} className="w-full h-full object-cover" data-id="element-320" data-mp="1ouin0x7lmyjz" />
                <div className="absolute inset-0 bg-gradient-to-t from-rise-black via-rise-black/20 to-transparent" data-id="element-321" data-mp="w5lcxhdjk82b"></div>
              </div>

              {/* Gold Top Line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold" data-id="element-322" data-mp="116rbhvtvupjr"></div>

              {/* Card Content */}
              <div className="p-8 md:p-[40px] pt-6 flex flex-col flex-grow" data-id="element-323" data-mp="2cjtqimgc371t">
                <div className="mb-6" data-id="element-324" data-mp="2clxrowmulrye">
                  <h3 className="font-playfair text-[20px] md:text-[22px] font-semibold mb-2 text-rise-gold" data-id="element-325" data-mp="2hiepkijunkoo">
                    {option.title}
                  </h3>
                  <p className="font-dm-sans text-[13px] uppercase tracking-wider font-semibold mb-4 text-rise-white/60" data-id="element-326" data-mp="3qhpmy6ungko8">
                    {option.subtitle}
                  </p>
                  <p className="font-dm-sans text-[19px] leading-relaxed text-rise-white/80" data-id="element-327" data-mp="3cgh8ggfrbtl">
                    {option.description}
                  </p>
                </div>

                <div className="flex-grow mb-8" data-id="element-328" data-mp="d81p2v86r6b9">
                  <ul className="space-y-4" data-id="element-329" data-mp="8ai296xf9l7p">
                    {option.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-330" data-mp="m26dl7zuk5nm" data-mpi={fIndex}>
                        <CheckCircle2 className="w-5 h-5 shrink-0 mt-1 text-rise-gold" data-id="element-331" data-mp="i01lwesylj3m" />
                        <span className="font-dm-sans text-[19px] text-rise-white/90" data-id="element-332" data-mp="i2ff0i42wl8j">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <a href={option.href} target="_top" className={`w-full py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center text-center ${option.buttonStyle}`} data-id="element-333" data-mp="1am9rl3wgoxjo">
                  {option.buttonText}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}